<template>
    <div>
        <el-dialog title="" :visible.sync="detailsShow" :close-on-click-modal="false" width="70%" ref="dialog"
            @close="detailsShow=false" top="5vh">
            <div>
                <div style="text-align: right;padding-right: 50px;">
                    <!-- TIPS：只在待回款时候存在 -->
                    <el-button type="primary" size="small" @click="confirmReturn()"
                        v-if="invoiceData && invoiceData.OfflineInvoiceStatus == 3">确认回款</el-button>

                    <el-button type="danger" size="small" @click="detailsShow=false" >关闭</el-button>
                    <!-- End -->
                </div>
                <el-form :inline="true" label-width="140px" label-position="left" v-loading="loading">
                    <el-row v-if="invoiceData">
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px;">
                                <h3 class="tk-head-title">申请信息</h3>
                            </div>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="申请人：" size="medium" class="item-width">
                                <div class="content-color">{{ invoiceData.ComWxApplyUser }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="账号：" size="medium" class="item-width">
                                <div class="content-color">{{
                                    (invoiceData.UserId > 0 ? invoiceData.UserName : invoiceData.CompanyName) }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="账号Code：" size="medium" class="item-width">
                                <div class="content-color">{{
                                    (invoiceData.UserId > 0 ? 'p' + invoiceData.UserId : 'e' + invoiceData.CompanyId) }}
                                </div>
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :lg="12">
                            <el-form-item label="申请时间：" size="medium" class="item-width">
                                <div class="content-color">{{ invoiceData.ComWxApplyTime || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px;">
                                <h3 class="tk-head-title">发票财务信息</h3>
                            </div>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="企微审批单号：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData.ComWxSpNo) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="是否需要回款：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.IsNeedReceiveMoney) ? "需要" : "不需要"
                                    }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="已收金额：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData.IsNeedReceiveMoney? ('¥'+invoiceData.ReceivedMoney):('¥'+invoiceData.InvoiceMoney)) }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="应收金额：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData.IsNeedReceiveMoney? ('¥'+invoiceData.InvoiceMoney):'--') }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="回款日期：" size="medium" class="item-width">
                                <div class="content-color">{{
                                    (invoiceData && invoiceData.InvoiceReturnPaymentsDt) || '--' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px;">
                                <h3 class="tk-head-title">开票信息</h3>
                            </div>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票Id：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.Id) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="是否是工单：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.IsJob ? "工单 ":"非工单") || '-' }}</div>
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票状态" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.OfflineInvoiceStatusName) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票抬头类型：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.InvoiceTitleType == 1)
                                    ? '企业' : '个人' }}</div>
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票抬头：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.InvoiceTitle) || '-'
                                    }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="单位地址：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.CompanyAddress) ||
                                    '-'
                                }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="单位电话：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.CompanyPhone) || '-'
                                    }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="用户开户银行：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.UserAccountOrgName) || '-' }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="用户银行账号：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.UserAccountNo) || '-' }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="开票金额：" size="medium" class="item-width">
                                <div class="content-color">￥{{ (invoiceData && invoiceData.InvoiceMoney) |
                                    formatPrice }}</div>
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :lg="12">
                            <el-form-item label="开票内容：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.InvoiceContent) ||
                                    '-'
                                }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="纳税人识别号：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.TaxNo) || '-' }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="规格型号：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.Specifications) ||
                                    '-'
                                }}</div>
                            </el-form-item>
                        </el-col>
                         <el-col :xs="24" :lg="12">
                            <el-form-item label="开票时间：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.InvoiceConfirmDt) ||
                                    '-'
                                }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="企微审批备注：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.ComWxAuditRemark) ||'-'}}</div>
                            </el-form-item>
                        </el-col>
                        <!--                         
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="开票税点：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.InvoiceinvoiceData.TaxPoint) || '-' }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票备注：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.InvoiceinvoiceData.InvoiceRemarks) ||
                                    '-'
                                }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="是否电子票：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.InvoiceinvoiceData.IsEInvoice ? '是' :
                                    '否') ||
                                    '-' }}</div>
                            </el-form-item>
                        </el-col>
                     
                        <el-col :xs="24" :lg="12" v-if="invoiceData && invoiceData.InvoiceinvoiceData.IsEInvoice">
                            <el-form-item label="额度/余额发票：" size="medium" class="item-width">
                                <div class="content-color">{{
                                    (invoiceData && invoiceData.InvoiceinvoiceData.ReceivedMoneyType == 1 ? '额度' : '余额') || '-'
                                    }}
                                </div>
                            </el-form-item>
                        </el-col> -->
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="银行到账日期：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData&&invoiceData.InvoiceReturnPaymentsOpDt) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                         <el-col :xs="24" :lg="12">
                            <el-form-item label="开户公司：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData&&invoiceData.BelongCompanyName) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="备注：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData&&invoiceData.ReceiveMoneyRemark) || '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px;">
                                <h3 class="tk-head-title">收件信息</h3>
                            </div>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="用户邮箱:" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.InvoiceMailAddress)
                                    ||
                                    '-' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="收件人：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.Consignee) || '-' }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="收件人电话：" size="medium" class="item-width">
                                <div class="content-color">{{ (invoiceData && invoiceData.ConsigneePhone) ||
                                    '-'
                                }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票文件：" size="medium" class="item-width">
                                <div class="content-color" v-if="invoiceData && invoiceData.InvoiceFileUrl">
                                    <!-- <el-button size="small" @click="downloadFile()">下载</el-button> -->

                                    <a target="_blank" @click="downloadFile(1)" v-if="invoiceData && invoiceData.InvoiceFileUrl">
                                        <img style="margin-bottom: -2px;height: 35px;width: auto;" src="@/assets/icon/pdf.png" alt="pdf发票" />
                                    </a>
                                <a target="_blank" @click="downloadFile(2)"  v-if="invoiceData && invoiceData.InvoiceXmlFileUrl">
                                    <img style="margin-bottom: -2px;margin-left: 5px;height: 35px;width: auto;" src="@/assets/icon/xml.png" alt="xml发票" />
                                </a>
                                   <a target="_blank" @click="downloadFile(3)"  v-if="invoiceData && invoiceData.InvoiceOfdFileUrl">
                                    <img style="margin-bottom: -2px;margin-left: 5px;height: 35px;width: auto;" src="@/assets/icon/ofd.png" alt="ofd发票" />
                                </a>
                                <span>{{ (invoiceData.InvoiceXmlFileUrl||invoiceData.InvoiceFileUrl||invoiceData.InvoiceOfdFileUrl) ? "" :"--"}}</span>

                                </div>
                                <div class="content-color" v-else>--</div>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px;">
                                <h3 class="tk-head-title">订单信息</h3>
                            </div>
                        </el-col>

                        <el-col :xs="24">
                            <el-table :data="jobTableData" border style="width: 100%;" max-height="450">
                                 <el-table-column prop="date" label="工单Id" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.Id || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="date" label="工单号" width="120" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.JobNo || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="name" label="工单名称" width="180" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.Title || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="来源" width="120" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.JobTypeName || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="发单方" width="180" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.SenderName || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="完成时间" width="160" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.CompleteTime || '--' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="金额" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.TrueTotalAmount | formatPrice }}</span>
                                    </template>
                                </el-table-column>
                                 <el-table-column prop="address" label="额度/余额" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.PayType  }}</span>
                                    </template>
                                </el-table-column>
                                 <el-table-column prop="address" label="结算状态" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.SettlementStatus }}</span>
                                    </template>
                                </el-table-column>
                                <!-- 用java接口时备注字段没有对应字段，好像没有意义，暂时保留 -->
                                <!-- <el-table-column prop="address" label="备注" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.remark || '--' }}</span>
                                    </template>
                                </el-table-column> -->
                                <!-- <el-table-column prop="address" label="操作" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-button size="mini" @click="exportExcel(1, scope.row)">下载</el-button>
                                    </template>
                                </el-table-column> -->
                            </el-table>
                        </el-col>

                    </el-row>
                    <!-- <el-row type="flex" justify="end">
                        <el-col :span="2">
                            <el-button size="small" @click="exportExcel(2,jobTableData)">下载全部</el-button>
                            <el-button size="small" @click="downloadFile()">下载全部</el-button>
                        </el-col>
                    </el-row> -->
                </el-form>
                <br />
                <br />
            </div>
        </el-dialog>
 
        <!-- 确认回款弹窗 -->
        <returnedShow  ref="returnedShowElem" from="offlineInvoiceDetail" @confirmReturnSuccess="confirmReturnSuccess"/>
    </div>
</template>
<script>

import {
    GetOfflineInvoiceDetails,
} from "@/service/payApi";
import returnedShow from './returnedShow'

export default {
    components: {
        returnedShow
    },

    data() {
        return {
            detailsShow: false,             //详情dialog 
   
            isTodayFlage: true,
            msgTip:'',

            id: 0,
            loading: false,
            invoiceData: null,
            jobTableData: []
        }
    },
    methods: {
        //获取线下发票信息
        open(id) {
            this.id = id;
            this.loading = true
            console.log('dataild-id:' + id)
            let res = GetOfflineInvoiceDetails({ id: id }).then(res => {

                // console.log("res:" + JSON.stringify(res));
                this.loading = false;
                if (res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.invoiceData = res.Data.Invoice;
                this.jobTableData = res.Data.JobList ;

                this.detailsShow = true;
            })
        },
        downloadFile(tt) {
            if(tt==1)
             {
                if (this.invoiceData && this.invoiceData.InvoiceFileUrl) {
                    // window.open(this.invoiceData.InvoiceFileUrl);
                      this.downloadFileViaXHR(this.invoiceData.InvoiceFileUrl,1);
                }
                else {
                    return this.$message.error('未找到发票文件')
                }
            }
            else if(tt==2)
            {
                if (this.invoiceData && this.invoiceData.InvoiceXmlFileUrl) {
                   this.downloadFileViaXHR(this.invoiceData.InvoiceXmlFileUrl,2);
                }
                else {
                    return this.$message.error('未找到XML发票文件')
                }
            }
              else if(tt==3)
            {
                if (this.invoiceData && this.invoiceData.InvoiceOfdFileUrl) {
                   this.downloadFileViaXHR(this.invoiceData.InvoiceOfdFileUrl,3);
                }
                else {
                    return this.$message.error('未找到XML发票文件')
                }
            }
        },

        //使用XHR方式下载xml文件，解决部分浏览器下载问题
        downloadFileViaXHR(url, tt) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            
            xhr.onload = function() {
                if (xhr.status === 200) {
                const blob = xhr.response;
                const blobUrl = URL.createObjectURL(blob);
                
                const link = document.createElement('a');
                link.href = blobUrl;

                 var name='';
                if(tt==1)
                {
                    name = 'invoice.pdf';
                }
                else if(tt==2)
                {
                    name = 'invoice.xml';
                }
                else if(tt==3)
                {
                    name = 'invoice.ofd';
                }
                link.download = name;
                link.style.display = 'none';
                
                document.body.appendChild(link);
                link.click();
                
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
                }
            };
            
            xhr.onerror = function() {
                console.error('下载失败');
            };
            xhr.send();
        },

        //显示确认回款弹窗
        confirmReturn() {
            var msg='';
            if(this.invoiceData&&!this.invoiceData.JobIsComplete){
                msg+='工单尚未完成，';
            }

            if(this.invoiceData&&this.invoiceData.JobTrueTotalRealAmount!=this.invoiceData.InvoiceMoney)
            {
                msg+= (msg==''?'':'且')+'发票金额和工单结算金额不等，';
            }
            if(msg!='')
            {
                msg+='不能进行回款操作';
            }
            this.msgTip=msg;
            this.$refs.returnedShowElem.open(this.invoiceData, this.id, this.invoiceData.IsHasJobDetail)
        },
        confirmReturnSuccess() {
            this.detailsShow = false
            this.$parent.GetInvoiceList();//刷发票管理列表
        },
    }
}
</script>
<style lang="scss">
.tk-head-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .tk-head-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
    }
}

.item-width {
    width: 100%;

    .el-form-item__content {
        width: calc(100% - 200px);
    }
}

.content-color {
    font-size: 16px;
    color: #333333;
}
.msgTip{
    background-color: #fdf6ec;
    color: #e6a23c;
    border-radius: 4px;
    padding: 8px;
    margin-left: 5px;
}
</style>